import Alpine from 'alpinejs';

Alpine.data('responsiveTables', () => ({
    init() {
        if (document.body.classList.contains('neos-backend')) {
            return;
        }
        this.$el.querySelectorAll('table').forEach(el => {
            this.processTable(el);
        });
    },
    wrap(el, wrapper) {
        el.parentNode.insertBefore(wrapper, el);
        wrapper.appendChild(el);
    },
    processTable(element) {
        if (!element) return;
        let heading;

        for (let columnIndex = 0; columnIndex < element.querySelectorAll('thead th').length; columnIndex++) {
            let rows = element.querySelectorAll('tbody tr');
            for (let rowIndex = 0; rowIndex < rows.length; rowIndex++) {
                heading = '<span class="responsive-element__table-heading">' + element.querySelectorAll('thead th')[columnIndex].innerHTML + '</span>';
                let td = rows[rowIndex].querySelectorAll('th,td')[columnIndex];
                if (td.tagName !== 'TH') {
                    td.innerHTML = heading + td.innerHTML;
                }
            }
        }

        let arrows = document.createElement("DIV");
        let arrowLeft = document.createElement("BUTTON");
        let arrowRight = document.createElement("BUTTON");
        let responsiveWrapper = document.createElement("DIV");

        arrows.classList.add('responsive-element__arrows');
        arrowLeft.classList.add('responsive-element__arrow', 'responsive-element__arrow--left', 'responsive-element__arrow--is-hidden');
        arrowRight.classList.add('responsive-element__arrow', 'responsive-element__arrow--right');
        responsiveWrapper.classList.add('responsive-element');

        arrows.appendChild(arrowLeft);
        arrows.appendChild(arrowRight);

        let wrapper;

        if (element.parentElement.classList.contains('table')) {
            wrapper = element.parentElement;
        } else {
            wrapper = document.createElement("FIGURE");
            wrapper.classList.add('table');

            this.wrap(element, wrapper);
        }

        this.wrap(wrapper, responsiveWrapper);
        responsiveWrapper.appendChild(arrows);

        // Add event listeners
        arrowLeft.addEventListener('click', (e) => {
            wrapper.scrollTo({
                top: 0,
                left: wrapper.scrollLeft - responsiveWrapper.getBoundingClientRect().width,
                behavior: 'smooth'
            });
        });

        arrowRight.addEventListener('click', (e) => {
            wrapper.scrollTo({
                top: 0,
                left: wrapper.scrollLeft + responsiveWrapper.getBoundingClientRect().width,
                behavior: 'smooth'
            });
        });

        // Show or hide arrows based on scroll position
        let showHideArrows = () => {
            let width = Math.round(wrapper.querySelector('table').getBoundingClientRect().width);
            let scrolled = Math.round(wrapper.scrollLeft + wrapper.getBoundingClientRect().width);
            if (scrolled >= width) {
                arrowRight.classList.add('responsive-element__arrow--is-hidden');
            } else {
                arrowRight.classList.remove('responsive-element__arrow--is-hidden');
            }
            if (wrapper.scrollLeft <= 0) {
                arrowLeft.classList.add('responsive-element__arrow--is-hidden');
            } else {
                arrowLeft.classList.remove('responsive-element__arrow--is-hidden');
            }
        };

        // Initial check and event listeners for scrolling and resizing
        showHideArrows();

        wrapper.addEventListener('scroll', e => {
            showHideArrows();
        });

        window.addEventListener('resize', e => {
            showHideArrows();
        });
    },
}));
